import { Divider, Spacer } from '@nextui-org/react';
import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

const CheckOrdersLayout = (): JSX.Element => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkIfMobile = (): void => {
      setIsMobile(window.matchMedia('(max-width: 1024px)').matches);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);
  return (
    <div className="flex grow flex-col">
      {/* Title */}
      <h1
        className={`${
          isMobile ? 'text-lg' : 'text-4xl'
        } font-bold text-foreground-800`}
      >
        Etiquetar Pedidos
      </h1>

      <Divider className="my-4" />

      <Spacer y={4} />

      <Outlet />
    </div>
  );
};

export default CheckOrdersLayout;
